<div class="autocomplete-wrapper">
<input
  type="text"
  class="form-control"
  name="place"
  [(ngModel)]="searchQuery"
  (input)="onInput()"
  [class.ng-invalid]="!hasSelectedPlace"
  [class.ng-valid]="hasSelectedPlace"
  required
  autocomplete="off"
/>

<ul *ngIf="predictions.length > 0" class="autocomplete-dropdown">
  <li
    *ngFor="let prediction of predictions"
    class="prediction-item"
    (click)="selectPlace(prediction)"
  >
    {{ prediction.description }}
  </li>
</ul>
</div>
